'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Alert = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = require('@material-ui/styles');

var _alert = require('../../schema/component/alert.json');

var _Typography = require('../Typography');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable arrow-body-style */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/no-extraneous-dependencies */


// Lazy Load
var InfoOutlinedIcon = (0, _react.lazy)(function () {
  return import('@material-ui/icons/InfoOutlined');
});
var ErrorOutlineIcon = (0, _react.lazy)(function () {
  return import('@material-ui/icons/ErrorOutline');
});
var ReportProblemOutlinedIcon = (0, _react.lazy)(function () {
  return import('@material-ui/icons/ReportProblemOutlined');
});

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    container: {
      boxSizing: 'border-box',
      background: function background(_ref) {
        var containerBackground = _ref.containerBackground;
        return containerBackground;
      },
      display: 'flex',
      padding: '8px 12px',
      maxWidth: '100%',
      width: function width(_ref2) {
        var containerWidth = _ref2.containerWidth;
        return containerWidth + ' !important';
      },
      '& .alert--icon': {
        marginRight: '8px'
      },
      '& .alert--text, & .alert--icon': {
        color: function color(_ref3) {
          var iconColor = _ref3.iconColor;
          return iconColor;
        }
      },
      '& .alert--children': {
        alignItems: 'center',
        display: 'flex',
        minHeight: '24px'
      }
    }
  };
});

var Alert = function Alert(_ref4) {
  var background = _ref4.background,
      children = _ref4.children,
      className = _ref4.className,
      color = _ref4.color,
      Icon = _ref4.Icon,
      textVariant = _ref4.textVariant,
      variant = _ref4.variant,
      width = _ref4.width,
      props = _objectWithoutProperties(_ref4, ['background', 'children', 'className', 'color', 'Icon', 'textVariant', 'variant', 'width']);

  var variantDefault = _alert.properties.info.properties;
  var variantSelected = _alert.properties[variant] && _alert.properties[variant].properties;
  var variantValidation = variantSelected || variantDefault;

  var classes = useStyles({
    containerBackground: background || variantValidation && variantValidation.background,
    containerWidth: width || variantValidation && variantValidation.width,
    iconColor: color || variantValidation && variantValidation.color
  });

  var Icons = function Icons() {
    switch (variant) {
      case 'info':
        return _react2.default.createElement(InfoOutlinedIcon, { className: 'alert--icon' });
      case 'error':
        return _react2.default.createElement(ReportProblemOutlinedIcon, { className: 'alert--icon' });
      case 'warning':
        return _react2.default.createElement(ErrorOutlineIcon, { className: 'alert--icon' });
      default:
        return _react2.default.createElement(InfoOutlinedIcon, { className: 'alert--icon' });
    }
  };

  return _react2.default.createElement(
    'div',
    _extends({}, props, { className: classes.container + ' ' + className }),
    _react2.default.createElement(
      _react.Suspense,
      { fallback: _react2.default.createElement('div', null) },
      Icon ? _react2.default.createElement(Icon, { className: 'alert--icon' }) : Icons()
    ),
    _react2.default.createElement(
      'div',
      { className: 'alert--children' },
      _react2.default.createElement(
        _Typography.Typography,
        {
          className: 'alert--text',
          variant: textVariant || variantValidation && variantValidation.textVariant,
          'data-display': 'inline-block',
          'data-width': 'auto'
        },
        children
      )
    )
  );
};

exports.Alert = Alert;
Alert.defaultProps = {
  background: null,
  children: null,
  className: null,
  color: null,
  Icon: null,
  textVariant: null,
  variant: 'info',
  width: null
};

Alert.propTypes = {
  background: _propTypes2.default.string,
  children: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  className: _propTypes2.default.string,
  color: _propTypes2.default.string,
  Icon: _propTypes2.default.string,
  textVariant: _propTypes2.default.string,
  variant: _propTypes2.default.string,
  width: _propTypes2.default.string
};

exports.default = Alert;